import Fetch from "../script/Fetch";
import { Articolo } from "orser-model/Articolo";

export class ArticoloService {
    async getArticoloById(id: any) {
        try {
            const response = await Fetch.doFetch(`/articolo/${id}`, {
                method: "GET"
            });
            const data = await response.json();
            return Articolo.fromJson(data);
        } catch (error: any) {
            console.error('Errore durante il recupero dei dati:', error.message);
        }
    }

    async getArticoloByIdForInsertOrModify(id: any) {
        try {
            const response = await Fetch.doFetch(`/articolo/${id}/forModify`, { method: "GET" });
            if (!response.ok) {
                throw new Error(`Server error: ${response.status}`);
            }
            const data = await response.json();
            return Articolo.fromJson(data);
        } catch (error: any) {
            console.error('Errore durante il recupero dei dati:', error.message);
        }
    }

    async getArticoloListByRistoranteId(ristoranteId: any) {
        const response = await Fetch.doFetch(`/ristorante/${ristoranteId}/articoli`, {
            method: "GET"
        });
        const data = await response.json();
        if (Array.isArray(data)) {
            return data.map((a: any) => Articolo.fromJson(a));
        }
        return [];
    }
}